import { render, staticRenderFns } from "./InternalNotesCard.vue?vue&type=template&id=36e4b9fa&"
import script from "./InternalNotesCard.vue?vue&type=script&lang=js&"
export * from "./InternalNotesCard.vue?vue&type=script&lang=js&"
import style0 from "./InternalNotesCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports